import { render, staticRenderFns } from "./CleanerLegendModal.vue?vue&type=template&id=44580d35"
import script from "./CleanerLegendModal.vue?vue&type=script&lang=js"
export * from "./CleanerLegendModal.vue?vue&type=script&lang=js"
import style0 from "./CleanerLegendModal.vue?vue&type=style&index=0&id=44580d35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports